

export const isFullScreenCategory = (categories, id) => {
    console.log(categories)
    console.log(id)
    return categories.find((value) => {
        return value.CATEGORY_ID === id
    }).is_full_screen_category;

}